import { Primary } from '../../../../core-components/theme/color-palette/colors';

const breakpoints = {
  mobile: '@media (max-width: 767px)',
  tablet: '@media (min-width: 768px) and (max-width: 1024px)',
};

const CreateEditTriggerStyles: any = {
  pageContainer: {
    padding: {
      xs: '16px',
      sm: '24px',
      md: '24px',
    },
    paddingTop: {
      xs: '10px',
      sm: '10px',
      md: '10px',
    },
    backgroundColor: '#ffffff',
    height: '100%',
  },

  sectionContainer: {
    marginBottom: '24px',
    padding: '12px',
    backgroundColor: '#F7FAFD',
    borderRadius: '8px',
    boxShadow: '0px',
    border: `1px solid ${Primary[100]}`,
  },
  sectionContainer2: {
    paddingTop: '12px',
    paddingBottom: '12px',
    paddingLeft: '20px',
    paddingRight: '12px',

    backgroundColor: '#ffffff',
    borderRadius: '8px',
    boxShadow: '0px',
    border: `1px solid ${Primary[100]}`,
  },

  sectionContainerObservation: {
    paddingTop: '12px',
    paddingBottom: '12px',
    paddingLeft: '20px',
    paddingRight: '12px',
    backgroundColor: '#ffffff',
    borderRadius: '8px',
    boxShadow: '0px',
    border: `1px solid ${Primary[100]}`,
  },

  sectionContainerResolution: {
    paddingTop: '12px',
    paddingBottom: '12px',
    paddingLeft: '20px',
    paddingRight: '12px',
    backgroundColor: '#ffffff',
    borderRadius: '8px',
    boxShadow: '0px',
    border: `1px solid ${Primary[100]}`,
  },

  plusIconContainer: {
    padding: '0px',
    width: 60,
    height: 60,
    backgroundColor: '#E0E0E0',
    borderRadius: '50%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    cursor: 'pointer',
    '&:hover': {
      backgroundColor: '#BDBDBD',
      borderRadius: '50%',
    },
  },
  conditionalPlusIconContainer: {
    padding: '0px',
    width: 30,
    height: 30,
    backgroundColor: '#E0E0E0',
    borderRadius: '50%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    cursor: 'pointer',
    '&:hover': {
      backgroundColor: '#BDBDBD',
      borderRadius: '50%',
    },
  },
  plusIconText: {
    color: '#757575',
    fontWeight: 'light',
    fontSize: '30px',
  },
  conditionalPlusIconText: {
    color: '#757575',
    fontWeight: 'light',
    fontSize: '20px',
  },
  recurringSectionContainer: {
    borderRadius: '8px',
    backgroundColor: '#ffffff',
    marginBottom: '16px',
  },
  typeLabel: {
    fontSize: '14px',
    color: '#666666',
    marginBottom: '16px',
  },
  typeLabelForPopup: {
    fontSize: '14px',
    color: '#666666',
    marginBottom: '0px',
  },
  responsiveMarginInline: {
    textAlign: 'center',
    fontSize: '14px',
    marginInline: {
      xs: 0,
      md: '20px',
    },
  },
  saveCancelContainer: { marginTop: '0px', marginBottom: '16px' },
  cancelButtonCustom: {
    borderColor: '#CCC',
    width: { xs: '30%', sm: '50%', md: '12%', xl: '12%' },
  },
  saveButtonCustom: {
    backgroundColor: Primary[500],
    width: { xs: '30%', sm: '50%', md: '12%', xl: '12%' },
    '&:hover': {
      backgroundColor: Primary[700],
    },
  },
  setConditionsButtonCustom: {
    backgroundColor: Primary[500],
    width: '100%',
    '&:hover': {
      backgroundColor: Primary[700],
    },
  },

  cancelButtonDialog: {
    borderColor: '#CCC',
    width: { xs: '30%', sm: '50%', md: '100%', xl: '100%' },
    margin: '5px',
    marginLeft: '25px',
  },
  saveButtonDialog: {
    backgroundColor: Primary[900],
    width: { xs: '30%', sm: '50%', md: '100%', xl: '100%' },
    '&:hover': {
      backgroundColor: Primary[700],
    },
    margin: '5px',
    marginRight: '25px',
  },

  saveCancelButtons: {
    display: 'flex',
    justifyContent: 'center',
    marginTop: '20px',
    [breakpoints.mobile]: {
      flexDirection: 'column',
      alignItems: 'center',
      gap: '10px',
    },
  },
  saveCancelButtonsCustom: {
    display: 'flex',
    justifyContent: 'end',
    marginTop: '20px',
    [breakpoints.mobile]: {
      flexDirection: 'column',
      alignItems: 'end',
      gap: '10px',
    },
  },

  communicationCheckBoxContainer: {
    border: '1px solid #CCC',
    borderRadius: 2,
    padding: 2,
    width: '100%',
    marginLeft: '0.5rem',
    marginTop: '10px',
  },
  taskTimeContainer: {
    border: '1px solid #CCC',
    borderRadius: 2,
    padding: 2,
    width: 'auto',
    marginLeft: '0.5rem',
    marginTop: '10px',
  },
};

export default CreateEditTriggerStyles;
